import { Component } from '@angular/core';

interface WhatWeDoTab {
  labelKey: string;
  icon: string;
  route: string;
}

const IMAGES = 'assets/images/what-we-do';

@Component({
  selector: 'what-we-do',
  templateUrl: './what-we-do.component.html',
  styleUrls: ['./what-we-do.component.css'],
})
export class WhatWeDoComponent {
  /* Each tab links to a child route, the panel below swaps */
  tabs: WhatWeDoTab[] = [
    { labelKey: 'WHAT-WE-DO_TAB-SMARTRESPONSE', icon: `${IMAGES}/tab-icon-sr.svg`, route: 'smart-response' },
    { labelKey: 'WHAT-WE-DO_TAB-RESEARCH', icon: `${IMAGES}/tab-icon-research.svg`, route: 'research' },
    { labelKey: 'WHAT-WE-DO_TAB-ADVOCACY', icon: `${IMAGES}/tab-icon-advocacy.svg`, route: 'advocacy' },
  ];
}
